export class File {
    ext: string;
    id: number;
    key: string;
    last_modified: string;
    name: string;
    original: string;
    original_name: string;
    size: number;
    small: string;
    large: string;

    constructor(data) {
        this.ext = data.ext;
        this.id = data.id;
        this.key = data.key;
        this.last_modified = data.last_modified;
        this.name = data.name;
        this.original = data.original;
        this.original_name = data.original_name;
        this.size = data.size;
        this.small = `https://www.ncahec.net/courses/images/${data.name.replace(' ', '+')}-sm.${data.ext}`
        this.large = `https://www.ncahec.net/courses/images/${data.name.replace(' ', '+')}-lg.${data.ext}`
    }
}